export default {"src":"/_next/static/image/public/images/mounjaro_rx.133fb1843c342331364ee3eebc8b7dff.svg","height":51,"width":51};